import { render } from "./reportSaleNameBill.vue?vue&type=template&id=3efd4172"
import script from "./reportSaleNameBill.vue?vue&type=script&lang=js"
export * from "./reportSaleNameBill.vue?vue&type=script&lang=js"

import "./reportSaleNameBill.vue?vue&type=style&index=0&id=3efd4172&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__